// extracted by mini-css-extract-plugin
export var actions = "_pw-4";
export var item = "_pw-1";
export var price = "_pw-3";
export var quantity = "_pw-2";
export var table = "_pw-0";